module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart4-fe58a027.svg";